import { Box, Typography } from "@mui/material";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";

const trustCards = [
  {
    icon: VerifiedUserOutlinedIcon,
    title: "Fair Play",
    description:
      "Built on blockchain",
  },
  {
    icon: PublicOutlinedIcon,
    title: "Global Access",
    description:
      "Play from anywhere",
  },
  {
    icon: LinkOutlinedIcon,
    title: "Powered by",
    description:
      "Smart Contracts",
  },
];

export default function HeroTrustCards() {
  return (
    <Box
      sx={{
        display: { xs: "flex", sm: "none" },
        flexDirection: "column",
        gap: (theme) => theme.custom.layoutSizes.section.gap.xs,
        width: "100%",
      }}
    >
      {trustCards.map((card) => {
        const Icon = card.icon;

        return (
          <Box
            key={card.title}
            sx={(theme) => ({
              display: "flex",
              alignItems: "center",
              gap: 2,
              p: { xs: 1, sm: 0 },
              border: "none",
              bgcolor: "transparent",
            })}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                width: 48,
                height: 48,
                borderRadius: "50%",
                bgcolor: (theme) => `${theme.palette.primary.main}1A`,
              }}
            >
              <Icon color="primary" />
            </Box>

            <Box>
              <Typography 
                variant="subtitle1" 
                sx={{ 
                  fontWeight: 700, 
                  lineHeight: 1.2, 
                  color: "text.primary", 
                  fontSize: "15px" 
                }}
              >
                {card.title}
              </Typography>

              <Typography
                variant="body2"
                sx={{ 
                  color: "text.secondary", 
                  mt: 0.5, 
                  fontSize: "12px" 
                }}
              >
                {card.description}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}